module.exports = __webpack_public_path__ + "static/media/l_itdot_14.b4b14eb9.png";